<template>
  <div :class="containerClasses">
    <!-- /* c8 ignore start */ -->
    <form
      novalidate
      class="confirm-emp-num__fields"
      @submit.prevent="$emit('form-submit')"
    >
      <cdr-input
        v-bind="field"
        :aria-describedby="!!field.error && `${field.id}-${field.name}`"
        :disabled="!isSignedIn"
        label="employee number"
        :model-value="field.value"
        :error="!!field.error"
        class="confirm-emp-num__field"
        @blur="$emit('blur')"
        @input="event => handleInput(event)"
      >
        <!-- /* c8 ignore end */ -->
        <template #error>
          <span :id="`${field.id}-${field.name}`">Please enter a valid employee number</span>
        </template>
      </cdr-input>

      <cdr-banner
        v-if="hasError"
        type="error"
        class="confirm-emp-num__error"
      >
        <template #icon-left>
          <icon-error-fill />
        </template>
        <cdr-text class="confirm-emp-num__error-text">
          <span v-dompurify-html="errorModel.firstHalf" />
          <cdr-link
            :href="errorModel.link.href"
            :data-analytics-id="errorModel.link.analyticsId"
            @click="handleContactUsClick"
          >
            {{ errorModel.link.text }}
          </cdr-link>
          <span v-dompurify-html="errorModel.secondHalf" />
        </cdr-text>
      </cdr-banner>

      <div :class="submitButtonClasses">
        <cdr-button
          :disabled="isComplete || !isSignedIn"
          type="submit"
        >
          <icon-check-lg v-if="isComplete" />
          {{ submitButtonText }}
        </cdr-button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  CdrBanner,
  CdrButton,
  CdrInput,
  CdrLink,
  CdrText,
  IconCheckLg,
  IconErrorFill,
} from '@rei/cedar';
import { metricsLink } from '#utils/analytics';

export default {
  name: 'ConfirmEmployeeNumber',
  components: {
    CdrBanner,
    CdrButton,
    CdrInput,
    CdrLink,
    CdrText,
    IconCheckLg,
    IconErrorFill,
  },
  props: {
    errorModel: {
      type: Object,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    isComplete: {
      type: Boolean,
      required: true,
    },
    isSignedIn: {
      type: Boolean,
      required: true,
    },
    hasError: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['blur', 'form-submit', 'form-input'],
  computed: {
    containerClasses() {
      return ['confirm-emp-num', { 'confirm-emp-num--complete': this.isComplete }];
    },
    submitButtonText() {
      return this.isComplete ? 'Employee number confirmed' : 'Confirm employee number';
    },
    submitButtonClasses() {
      return {
        'confirm-emp-num__submit': true,
        'confirm-emp-num__submit--is-complete': this.isComplete,
      };
    },
  },
  methods: {
    /* c8 ignore start */
    handleInput(event) {
      const { value } = event.target;
      this.$emit('form-input', { value });
    },
    handleContactUsClick() {
      metricsLink(this.errorModel.link.analyticsId);
    },
    /* c8 ignore end */
  },
};
</script>

<style lang="scss">

@import '@rei/cdr-component-variables/dist/scss/CdrButton.vars.scss';
.confirm-emp-num__field {
  margin-bottom: $cdr-space-one-x;
}

.confirm-emp-num__submit--is-complete {
  button[disabled] {
    @include confirmed-disabled-button;
  }

  svg {
    height: 20px!important;
    width: 20px!important;
  }
}

.confirm-emp-num__error {
  margin-bottom: $cdr-space-one-x;
  [class*=cdr-banner__message] {
    padding: $cdr-space-inset-quarter-x-stretch-top-bottom $cdr-space-inset-half-x;
  }
}

.confirm-emp-num__error-text {
  @include cdr-text-utility-sans-200;
}
</style>
